<template>
  <v-btn
      :class=getButtonClass()
      :outlined="outlined"
      :disabled="disabled"
      :type="type"
      :loading="loading"
      :x-large="xLarge"
      :block="fullWidth"
      :btn-icon="btnIcon"
      :icon-only="iconOnly"
      variant="flat"
      @click="onSubmit(label)">

    <v-row v-if="btnIcon" class="align-center justify-center">
      <v-icon size="34">{{ btnIcon }}</v-icon>
      <span v-if="!iconOnly">{{ label }}</span>
    </v-row>
    <div v-else>
      <span v-if="!iconOnly">{{ label }}</span>
    </div>
  </v-btn>
</template>


<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean
    },
    type: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean
    },
    fullWidth: {
      type: Boolean
    },
    xLarge: {
      type: Boolean
    },
    btnIcon: {
      type: String,
      required: false,
    },
    iconOnly: {
      type: Boolean
    },
    outlined: {
      type: Boolean
    }
  },
  methods: {
    onSubmit(value = null): void {
      this.$emit("callback", value);
    },
    getButtonClass(): string {
      let res = "base";
      if (this.disabled || this.loading) {
        res = "disabled"
      }
      if (this.outlined && (!this.disabled || this.loading)) {
        res = "outlined"
      }
      return res;
    }
  }
})
</script>


